function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { createRef, PureComponent } from "react";
import debounce from "lodash/debounce";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import classNames from "classnames";
var ChartQuickNav = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ChartQuickNav, PureComponent);
    var _super = _createSuper(ChartQuickNav);
    function ChartQuickNav(props) {
        _classCallCheck(this, ChartQuickNav);
        var _this;
        _this = _super.call(this, props);
        _this.onChange = function(evnt) {
            var _v;
            if (isNaN(evnt) && evnt.preventDefault) {
                evnt.preventDefault();
                evnt.stopPropagation();
                _v = evnt.target.value;
            } else {
                _v = evnt;
            }
            var maxSlides = _this.props.maxSlides;
            var value = _v > maxSlides ? maxSlides : _v <= 0 ? 1 : _v;
            _this.setState({
                value: value
            });
        };
        _this.onChangeText = function(evnt) {
            var _v = evnt.target.value;
            _this.setState({
                textValue: _v
            });
        };
        _this.onSetChart = function() {
            var value = _this.state.value;
            var _this_props = _this.props, goTo = _this_props.goTo, currentSlideIndex = _this_props.currentSlideIndex;
            if (!goTo(value)) {
                _this.setState({
                    value: currentSlideIndex,
                    textValue: String(currentSlideIndex)
                });
            }
        };
        _this.onFocusText = function(evnt) {
            var target = evnt.target;
            // Select text on "ordinary" devices
            target.select();
            // Select text on iOS Devices:
            if (target.setSelectionRange) {
                setTimeout(function() {
                    target.setSelectionRange(0, 9999);
                }, 1);
            }
        };
        _this.onKeyPressText = function(evnt) {
            if (evnt.key === "Enter") {
                if (_this.isValidTextValue()) {
                    _this.setState({
                        value: parseInt(_this.state.textValue, 10)
                    });
                    _this.onSetChart();
                } else {
                    _this.setState({
                        textValue: String(_this.state.value)
                    });
                }
            }
        };
        _this.isValidTextValue = function() {
            var textValue = _this.state.textValue;
            var maxSlides = _this.props.maxSlides;
            var textValueInt = parseInt(textValue, 10);
            return textValueInt >= 1 && textValueInt <= maxSlides;
        };
        _this.state = {
            value: props.currentSlideIndex,
            textValue: String(props.currentSlideIndex)
        };
        _this.inputRef = /*#__PURE__*/ createRef();
        _this.onSetChart = debounce(_this.onSetChart, 300);
        return _this;
    }
    var _proto = ChartQuickNav.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this_props = this.props, currentSlideIndex = _this_props.currentSlideIndex, visible = _this_props.visible;
        // Outer component can change the local cached current value:
        if (prevProps.currentSlideIndex !== currentSlideIndex) {
            this.setState({
                value: currentSlideIndex,
                textValue: String(currentSlideIndex)
            });
        }
        if (!prevProps.visible && visible) {
            var _this_inputRef, _this_inputRef_current, _this_inputRef_current_node;
            var sliderNode = (_this_inputRef = this.inputRef) === null || _this_inputRef === void 0 ? void 0 : (_this_inputRef_current = _this_inputRef.current) === null || _this_inputRef_current === void 0 ? void 0 : (_this_inputRef_current_node = _this_inputRef_current.node) === null || _this_inputRef_current_node === void 0 ? void 0 : _this_inputRef_current_node.querySelector('[role="slider"]');
            sliderNode === null || sliderNode === void 0 ? void 0 : sliderNode.focus();
        }
    };
    _proto.render = function render() {
        var _this_props = this.props, maxSlides = _this_props.maxSlides, visible = _this_props.visible;
        var _this_state = this.state, value = _this_state.value, textValue = _this_state.textValue;
        var inputClasses = classNames("chart-progress__number", {
            "chart-progress__number-invalid": this.isValidTextValue()
        });
        return visible && /*#__PURE__*/ React.createElement("div", {
            className: "chart-progress__popup"
        }, /*#__PURE__*/ React.createElement(InputRange, {
            ref: this.inputRef,
            value: value || 1,
            minValue: 1,
            maxValue: maxSlides || 2,
            onChange: this.onChange,
            onChangeComplete: this.onSetChart
        }), /*#__PURE__*/ React.createElement("input", {
            className: inputClasses,
            id: "current-slide-input",
            type: "text",
            value: textValue,
            onFocus: this.onFocusText,
            onChange: this.onChangeText,
            onKeyPress: this.onKeyPressText
        }), /*#__PURE__*/ React.createElement("label", {
            className: "sr-only",
            htmlFor: "current-slide-input"
        }, "current slide"), /*#__PURE__*/ React.createElement("span", {
            "aria-hidden": true
        }, "\xa0/\xa0", maxSlides));
    };
    return ChartQuickNav;
}(PureComponent);
export default ChartQuickNav;
